import React from 'react'
import { MultiSelect } from 'primereact/multiselect'
import { Calendar } from 'primereact/calendar'
import { RadioButton } from 'primereact/radiobutton'
import utils from '../../../utils/index'
import LtsMultiselectUnidade from '../../../components/lottus/lts-multiselect-unidade'

/**
 * noAgendamento: o formulario dentro do dialogo de agendamento (AgendarRelatorioDialog), sem as datas (que la vao
 * para a grade de formulas) e sem seguir a unidade escolhida no topo.
 */
export const ReceitasDespesasRelatorioForm = (props) => {
  const record = props.record
  const changeHandler = props.changeHandler
  // no dialogo de agendamento a tela continua montada por baixo: com os mesmos ids, clicar no rotulo de um tipo de
  // relatorio marcaria a opcao da tela, nao a do dialogo
  const sufixoId = props.noAgendamento ? 'Agendamento' : ''

  return (
    <div>
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
                <LtsMultiselectUnidade
                  name="unidade"
                  label="Unidade"
                  value={record.unidade}
                  onChange={(e) => props.onChangeUnit(e)}
                  ignorarUnidadeDoTopo={props.noAgendamento}
                />
              </div>
            </div>

            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
                <span className="p-float-label">
                  <MultiSelect
                    value={record.tipoFormaPagamento}
                    options={utils.convertArrayIdValueToIdLabel(props.formasPagamento)}
                    name="tipoFormaPagamento"
                    optionLabel="label"
                    dataKey="id"
                    selectedItemsLabel="{0} itens selecionados"
                    onChange={changeHandler}
                  />
                  <label>Forma de Pagamento</label>
                </span>
              </div>
            </div>

            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
                <span className="p-float-label">
                  <MultiSelect
                    value={record.gruposFinanceiros}
                    options={utils.convertArrayIdValueToIdLabel(record.gruposFinanceirosOpcoes)}
                    name="gruposFinanceiros"
                    optionLabel="label"
                    dataKey="id"
                    selectedItemsLabel="{0} itens selecionados"
                    onChange={changeHandler}
                    filter={true}
                  />
                  <label>Grupo Financeiro</label>
                </span>
              </div>
            </div>
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
                <span className="p-float-label">
                  <MultiSelect
                    value={record.tiposSepulturas}
                    options={utils.convertArrayIdValueToIdLabel(record.opcoesTiposSepulturas)}
                    name="tiposSepulturas"
                    optionLabel="label"
                    dataKey="id"
                    selectedItemsLabel="{0} itens selecionados"
                    onChange={props.changeHandler}
                  />
                  <label>Tipo de Sepultura</label>
                </span>
              </div>
            </div>
            {!props.noAgendamento && (
              <div className="p-grid form-group">
                <div className="p-col-5 p-sm-4 p-md-2 p-lg-2 p-xl-2">
                  <span className="p-float-label">
                    <Calendar
                      yearNavigator={true}
                      yearRange={utils.getYearRangeFromDate('1970')}
                      monthNavigator={true}
                      value={record.dataInicial}
                      onChange={changeHandler}
                      name="dataInicial"
                    />
                    <label>Período: De</label>
                  </span>
                </div>
                <div className="p-col-5 p-sm-4 p-md-2 p-lg-2 p-xl-2">
                  <span className="p-float-label">
                    <Calendar
                      yearNavigator={true}
                      yearRange={utils.getYearRangeFromDate('1970')}
                      monthNavigator={true}
                      value={record.dataFinal}
                      onChange={changeHandler}
                      name="dataFinal"
                    />
                    <label>Até</label>
                  </span>
                </div>
              </div>
            )}
            <br />
            <div className="p-field-radiobutton">
              <RadioButton
                inputId={'tipoRelatorioReceitasAnaliticas' + sufixoId}
                name="tipoRelatorio"
                value={1}
                checked={record.tipoRelatorio === 1}
                onChange={changeHandler}
              />
              <label htmlFor={'tipoRelatorioReceitasAnaliticas' + sufixoId}>Receitas Análiticas</label>
            </div>
            <div className="p-field-radiobutton">
              <RadioButton
                inputId={'tipoRelatorioReceitasSintetico' + sufixoId}
                name="tipoRelatorio"
                value={2}
                checked={record.tipoRelatorio === 2}
                onChange={changeHandler}
              />
              <label htmlFor={'tipoRelatorioReceitasSintetico' + sufixoId}>Receitas Sintético</label>
            </div>
            <div className="p-field-radiobutton">
              <RadioButton
                inputId={'tipoRelatorioDespesasAnaliticas' + sufixoId}
                name="tipoRelatorio"
                value={3}
                checked={record.tipoRelatorio === 3}
                onChange={changeHandler}
              />
              <label htmlFor={'tipoRelatorioDespesasAnaliticas' + sufixoId}>Despesas Analíticas</label>
            </div>
            <div className="p-field-radiobutton">
              <RadioButton
                inputId={'tipoRelatorioDespesasSinteticas' + sufixoId}
                name="tipoRelatorio"
                value={4}
                checked={record.tipoRelatorio === 4}
                onChange={changeHandler}
              />
              <label htmlFor={'tipoRelatorioDespesasSinteticas' + sufixoId}>Despesas Sintético</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
